const store = {
    conversationsSocket: null,
};

export default store;
